import Image from './ImageView'
export default Image
